import { render, staticRenderFns } from "./itemLoading.vue?vue&type=template&id=41823082&scoped=true&"
import script from "./itemLoading.vue?vue&type=script&lang=js&"
export * from "./itemLoading.vue?vue&type=script&lang=js&"
import style0 from "./itemLoading.vue?vue&type=style&index=0&id=41823082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41823082",
  null
  
)

export default component.exports